module.exports = __webpack_public_path__ + "img/com.moji.mjweather.a743b573.png";